import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot} from '@angular/router';
import {Socket} from 'ngx-socket-io';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivate {
  constructor(
    private router: Router,
    private socket: Socket) {
    console.log('in authen');
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    const returnUrl =
      state.url.indexOf('app') < 0 ? `/app${state.url}` : state.url;
    if (
      localStorage.getItem('access_token') ||
      state.url.indexOf('/auth/') >= 0
    ) {
      if (localStorage.getItem('access_token')) {
        this.socketAuth(localStorage.getItem('access_token'));
      }
      return true;
    }
    if (state.url.indexOf('/auth/') >= 0) {
      this.router.navigate(['/auth/signin']);
    } else {
      this.router.navigate(['/auth/signin'], {
        queryParams: { returnUrl },
      });
    }
    return false;
  }

  socketAuth(token: string) {
    this.socket.emit('subscribe', { token }, (data: any) => {
      if (data.status === 1000) {
        console.log('Socket connected');
      }
    });
  }
}
